import React from 'react';
import {Component} from 'react';
import { withRouter, Route, Switch } from 'react-router' // react-router v4
import MainView from './MainView';
import Data from './Data.js'

class App extends Component {
  render() {
    return (
      <Switch>
        <Route key={ "main" } 
          path={ process.env.PUBLIC_URL+"/" } exact 
          render={ (props) => ( <MainView data={ Data.pl } lang="pl" /> ) }/>
        <Route key={ "main-en" } 
          path={ process.env.PUBLIC_URL+"/en" } exact 
          render={ (props) => ( <MainView data={ Data.en } lang="en" /> ) }/>
      </Switch>
    );
  }
}

export default withRouter(App);
